import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ImageBuiltInControl} from '../ImageBuiltInControl';

export abstract class ImageVisibilityBuiltInControl extends ImageBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.HIDDEN_NODE;
  }
}
